export class ProposalProjectObjective{
    constructor(id,  title, description, proposalProject){
        this.id = id;
        this.title = title;
        this.description = description;
        this.proposalProject = proposalProject;
    }
    static createFromResponseData(responseData){
        return new ProposalProjectObjective(
            responseData.id,
            responseData.title,
            responseData.description,
            responseData.proposalProject
        );
    }
};